const PACKAGE_COMPONENT_PREFIX = 'animated-'

export default PACKAGE_COMPONENT_PREFIX



// WEBPACK FOOTER //
// ./src/animates/animated-vue/common/config/index.js